/*
 * sentryio.js
 * configuration options for sentry.io
 */

module.exports = {
   dsn: ".........."
};
